import { QueryClient } from "@tanstack/vue-query";
let sharedQueryClient = null;
const createQueryClient = () => {
    return new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 5 * 60 * 1000,
                gcTime: 10 * 60 * 1000,
                retry: 1,
                refetchOnWindowFocus: false,
                throwOnError: (error) => {
                    console.error("Query error:", error);
                    return false; // Don't throw, keep component mounted
                },
            },
            mutations: {
                onError: (error) => {
                    console.error("Mutation error:", error);
                },
            },
        },
    });
};
export const getSharedQueryClient = () => {
    if (!sharedQueryClient) {
        sharedQueryClient = createQueryClient();
    }
    return sharedQueryClient;
};
